import { call, select, put } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '@APIs/common/service-locator';
import { getSsapData, getStructure } from '@reducers/appReducer';
import { processUiProperties } from '@utils/tools/processUiProperties';
import { processJsonTools } from '@utils/tools/processJsonTools';
import { checkBloodRelationshipsFailure, checkBloodRelationshipsSuccess } from '@actions/ssap/ssapActionCreators';
import { executeCallbacks } from '@utils/miscellaneous/executeCallbacks';
import { updateDisabledUi } from '@actions/ssap/ssapActionCreators';

export function* bloodRelationshipsCheckSaga({ callback }) {
    try {
        const data = yield select(getSsapData);
        const { taxHouseholdStructure, bloodRelationshipStructure } = yield select(getStructure);
        const ssapService = yield call(serviceLocator, SSAP_SVC);
        const payload = processUiProperties(
            processJsonTools
                .convertTaxHousehold(
                    processJsonTools
                        .convertBloodRelationships(data, bloodRelationshipStructure),
                    taxHouseholdStructure
                )
        );
        const response = yield call([ssapService, ssapService.checkBloodRelationships], payload);

        if(response) {
            const {
                message,
                success
            } = response;
            if(success) {
                yield call(executeCallbacks, callback);
            } else {
                yield put(updateDisabledUi({
                    allInputsDisabled: true,
                    isVisible: true,
                    buttonsDisabled: ['leftButton', 'middleButton', 'rightButton'],
                    errorMessageReplacements: message
                }));
            }
            yield put(checkBloodRelationshipsSuccess());
        } else {
            yield put(checkBloodRelationshipsFailure());
        }
    } catch(e) {
        yield put(checkBloodRelationshipsFailure());
    }
}